import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';
import { VideoPlayerService } from './videoplayer.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-dialog-yesno',
  templateUrl: 'dialog-video.component.html',
  styleUrls: ['dialog-video.component.scss'],
})
export class DialogVideoComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<DialogVideoComponent>);
  private readonly videoPlayerService = inject(VideoPlayerService);
  readonly data = inject(MAT_DIALOG_DATA);
  
  videoUrl = signal<SafeResourceUrl | undefined>(undefined);

  public ngOnInit(): void {
    const embedUrl = this.videoPlayerService.embedWithSound(this.data.videoUrl);
    this.videoUrl.set(embedUrl);
  }

  public close(): void {
    this.dialogRef.close();
  }
}
